module.exports = __webpack_public_path__ + "img/service-phone@3x.beee82ee.png";